/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./stack.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Children } from 'react';
const listStyles = null;
const listItemStyles = null;
const Stack = ({
  children,
  testId,
  'aria-label': label
}) => /*#__PURE__*/React.createElement("ul", {
  "data-testid": testId,
  "aria-label": label,
  className: ax(["_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"])
}, Children.map(children, child => child && /*#__PURE__*/React.createElement("li", {
  className: ax(["_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t"])
}, child)));

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Stack;